import React from 'react';
import Icon from 'eventbrite_design_system/icon/Icon';
import RefreshChunckySvg from 'eventbrite_design_system/iconography/icons/RefreshChunky';
import Button from 'eventbrite_design_system/button/Button';

import './RefreshContent.scss';

const RefreshContent = (props) => {
    const {
        onClickHandler,
    } = props;

    return (
        <div className="refresh-content">
            <div className="refresh-content--message eds-text-weight--heavy">
                Whoa, something weird happened here. Try refreshing this section.
            </div>
            <div className="refresh-content--button">
                <Button style="none" onClick={onClickHandler}>
                    <Icon type={<RefreshChunckySvg />} size="small" />
                </Button>
            </div>
        </div>
    );
};

export default RefreshContent;


// WEBPACK FOOTER //
// ./src/components/RefreshContent/RefreshContent.js